import React, { useState, useEffect } from 'react';
import { USBButton } from '@usb-shield/forms-beta';
import {
    USBIconSuccess,
    USBIconPeople,
    USBIconClock,
    USBIconList,
    USBIconSave,
    USBIconInfo,
} from '@usb-shield/react-icons';
import { useDispatch } from 'react-redux';
import styles from './dynamicLanding.module.scss';
import { RelationshipNameFieldError } from '../../redux/actions';
import RelationshipName from '../../atoms/RelationshipName';

function Landing({
    // title,
    content,
    // imageUrl,
    handleNextClick,
    // goBack,
    relationshipName: name,
    fieldError,
}) {
    const dispatch = useDispatch();
    const [relationshipName, setRelationShipName] = useState(name);

    useEffect(() => {
        setRelationShipName(name);
    }, [name]);

    // handle onchange of relationshipname box
    const handleRelationshipNameChange = (e) => {
        dispatch(RelationshipNameFieldError(e));
        const value = e.inputValue;
        setRelationShipName(value);
    };
    return (
        <>
            <div className={styles['main-content-wrapper']}>
                <div className={styles['main-left-content']}>
                    <h1 className={styles.title}>
                        {content.startPageHeader}
                    </h1>
                    <div className={styles.content}>
                        <section
                            className={styles['content-wrapper']}
                        >
                            <p
                                className={
                                    styles[
                                        'landing-content-section-1'
                                    ]
                                }
                            >
                                {content.productDescription}
                            </p>
                            <section
                                className={
                                    styles[
                                        'landing-content-section-2'
                                    ]
                                }
                            >
                                <h2
                                    className={`${styles['section-sub-heading']} ${styles['section-sub-heading-main']}`}
                                >
                                    {content.youWillNeedHeader}
                                </h2>
                                <p
                                    className={
                                        styles['icon-text-wrapper']
                                    }
                                >
                                    <span
                                        className={
                                            styles['icon-wrapper']
                                        }
                                    >
                                        <USBIconSuccess />
                                    </span>
                                    <span
                                        className={
                                            styles[
                                                'you-will-need-content'
                                            ]
                                        }
                                    >
                                        {content.youWillNeedContent}
                                    </span>
                                </p>
                            </section>
                            <section
                                className={
                                    styles[
                                        'landing-content-section-3'
                                    ]
                                }
                            >
                                <h2
                                    className={
                                        styles['section-sub-heading']
                                    }
                                >
                                    {content.keepInMindHeader}
                                </h2>
                                <ul
                                    className={
                                        styles['section-3-list']
                                    }
                                >
                                    <li
                                        className={
                                            styles[
                                                'icon-text-wrapper'
                                            ]
                                        }
                                    >
                                        <span
                                            className={
                                                styles['icon-wrapper']
                                            }
                                        >
                                            <USBIconPeople
                                                size={24}
                                            />
                                        </span>
                                        {content.salesProcesstext}
                                    </li>
                                    <li
                                        className={
                                            styles[
                                                'icon-text-wrapper'
                                            ]
                                        }
                                    >
                                        <span
                                            className={
                                                styles['icon-wrapper']
                                            }
                                        >
                                            <USBIconClock size={24} />
                                        </span>
                                        {content.listOfQuestionstext}
                                    </li>
                                    <li
                                        className={
                                            styles[
                                                'icon-text-wrapper'
                                            ]
                                        }
                                    >
                                        <span
                                            className={
                                                styles['icon-wrapper']
                                            }
                                        >
                                            <USBIconList size={24} />
                                        </span>
                                        {
                                            content.suggestedProductsText
                                        }
                                    </li>
                                    <li
                                        className={
                                            styles[
                                                'icon-text-wrapper'
                                            ]
                                        }
                                    >
                                        <span
                                            className={
                                                styles['icon-wrapper']
                                            }
                                        >
                                            <USBIconSave size={24} />
                                        </span>
                                        {content.emailCopyText}
                                    </li>
                                    <li
                                        className={
                                            styles[
                                                'icon-text-wrapper'
                                            ]
                                        }
                                    >
                                        <span
                                            className={
                                                styles['icon-wrapper']
                                            }
                                        >
                                            <USBIconInfo size={24} />
                                        </span>
                                        {content.productsInfoText}
                                    </li>
                                </ul>
                            </section>
                            <h2
                                className={
                                    styles['section-sub-heading']
                                }
                            >
                                {content.clientRelationshipNameLabel}
                            </h2>
                            <section>
                                <RelationshipName
                                    statusUpdateCallback={(e) =>
                                        handleRelationshipNameChange(
                                            e,
                                        )
                                    }
                                    selectedValue={relationshipName}
                                    fieldError={fieldError}
                                />
                            </section>
                        </section>
                    </div>

                    <div className={styles['button-container']}>
                        <USBButton
                            variant="primary"
                            ariaLabel="Start questionnaire"
                            onSubmit={() =>
                                handleNextClick(relationshipName)
                            }
                        >
                            Get started
                        </USBButton>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Landing;
